import React, { useState, useEffect } from "react";
import { Box, Select, MenuItem, Checkbox, FormControlLabel, Button, Typography } from "@mui/material";
import axiosInstance from "../../axios/axios";
import { Toast } from "../../Common_Components/Toast";
import SaveButton from "../../Common_Components/SaveButton";

const UserPrevilege = () => {
    const [roles, setRoles] = useState([]);
    const [privileges, setPrivileges] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [rolePrivileges, setRolePrivileges] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchRoles();
        fetchPrivileges();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axiosInstance.get("/users/listUserRole"); // Adjust endpoint
            const { success, userRoles } = response.data;
            if (success === true) {
                setRoles(userRoles);
            } else {
                setRoles([]);
            }
        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };

    const fetchPrivileges = async () => {
        try {
            const response = await axiosInstance.get("/users/listPrevilege"); // Adjust endpoint
            const { success, userPrevilege } = response.data;
            if (success === true) {
                setPrivileges(userPrevilege);
            } else {
                setPrivileges([]);
            }
        } catch (error) {
            console.error("Error fetching privileges:", error);
        }
    };

    const handleRoleChange = async (event) => {
        const roleId = event.target.value;
        setSelectedRole(roleId);
        setLoading(true);
        if (roleId) {
            try {
                const response = await axiosInstance.get(`/users/getprevilegeByID/${roleId}`); // Adjust endpoint
                const { success, privileges } = response.data;
                if (success === true) {
                    const assignedPrivileges = privileges && privileges.map((priv) => priv);
                    setRolePrivileges(assignedPrivileges);
                }
            } catch (error) {
                console.error("Error fetching role privileges:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handlePrivilegeToggle = (privilegeId) => {
        setRolePrivileges((prev) =>
            prev.includes(privilegeId)
                ? prev.filter((id) => id !== privilegeId)
                : [...prev, privilegeId]
        );
    };

    const savePrivileges = async () => {
        if (!selectedRole) {
            Toast.warning("Please Select a role");
            return;
        }
        try {
            const response = await axiosInstance.post("/users/assignPrevilege", {
                roleId: selectedRole,
                privilegeIds: rolePrivileges,
            });
            const { success, message } = response.data;
            if (success === true) {
                Toast.success(message);
            } else {
                Toast.warning(message);
            }
        } catch (error) {
            console.error("Error saving privileges:", error);
            Toast.error("Failed to save privileges.");
        }
    };

    return (
        <Box p={3}>
            <Typography sx={{
                fontFamily: 'Times New Roman',
                fontWeight: '700',
                fontSize: '32px',
                color: '#545454',
            }}>
                Privilege Management
            </Typography>
            <Box mb={2} mt={2}>
                <Select
                    value={selectedRole}
                    onChange={handleRoleChange}
                    displayEmpty
                    sx={{ width: 300 }}
                >
                    <MenuItem value="" disabled>
                        Select Role
                    </MenuItem>
                    {roles.map((role) => (
                        <MenuItem key={role.RL_ID} value={role.RL_ID}>
                            {role.RL_Name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            <Box mb={2} display="flex" flexWrap="wrap" gap={2}>
                {loading ? (
                    <p>Loading privileges...</p>
                ) : (
                    privileges.map((priv, index) => (
                        <Box
                            key={priv.PL_Id}
                            sx={{
                                flexBasis: "20%", // 100% / 5 columns = 20%
                                maxWidth: "20%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="secondary"
                                        checked={rolePrivileges.includes(priv.PL_Id)}
                                        onChange={() => handlePrivilegeToggle(priv.PL_Id)}
                                    />
                                }
                                label={priv.PL_Name}
                            />
                        </Box>
                    ))
                )}
            </Box>
            <SaveButton
                onClick={savePrivileges}
                disabled={!selectedRole}
                label={"Save"}
            />
        </Box>
    );
};

export default UserPrevilege;
